module.exports = __webpack_public_path__ + "img/poliritmika.868dc36c.png";